import * as React from 'react';
import { Link } from 'react-router-dom';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const style = css`
    margin: 0 auto;
	align-self: center;
	
    .message {
		text-align: center;
    }
`;

export default (props) => {
	return <div css={style}>
		<div className="message">
			<h1>Route Not Found</h1>
			<Link to="/">Go to Dashboard</Link>
		</div>
	</div>
};